var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.$vuetify.breakpoint.mobile)?_c('mobile-navbar'):_c('desktop-navbar')
}
var staticRenderFns = []

export { render, staticRenderFns }